import jquerySource from 'jquery-source';

if (!window.jQuery && !globalThis.jQuery) {
  // Execute the legacy bundle outside the webpack module wrapper.
  // The file expects top-level this to resolve to the global object.
  new Function(jquerySource)();
}

const resolvedJQuery = window.jQuery || globalThis.jQuery;

if (typeof resolvedJQuery !== 'function') {
  throw new Error('jQuery global was not initialized');
}

window.$ = resolvedJQuery;
window.jQuery = resolvedJQuery;

export default resolvedJQuery;
